/*
 * ttl Sagas
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio/DESKTOP-LBDL00N
 * @since 01-Oct-2024
 */

import { put, all, takeLatest, delay } from 'redux-saga/effects'
import { doPopup } from 'Store/actions/popup'
import { UNAUTH_ROUTES } from 'Schemas/constants'
import { routesList } from 'Schemas/routesList'
import moment from 'moment'
import { redirectToLogin, updateTTL } from 'Utility/globalMethods'
import * as actions from 'Store/actions/ttl'

const timeFormat = 'HH:mm:ss'
const regexFromMyArray = new RegExp(UNAUTH_ROUTES.join('|'))
const currentPath = window.location.pathname
const isMock = process.env.ISMOCK

export function* ttlControl() {
  if (!regexFromMyArray.test(currentPath) && !isMock) {
    const sessionObj = window.sessionStorage.getItem('TTL') ?? false

    if (sessionObj) {
      const { TTL: ttl, DAY: day } = JSON.parse(sessionObj)
      const now = moment()
      const nowTime = now.format(timeFormat)
      const nowDate = now.format('DD')
      const timePlusOneMinute = now.add(1, 'minutes').format(timeFormat)

      if (timePlusOneMinute >= ttl && currentPath !== routesList.goToLogin) {
        yield put(doPopup('EXTEND_SESSION'))
      }
      if (nowDate > day || nowTime >= ttl) {
        if (currentPath === routesList.goToLogin) {
          yield redirectToLogin()
        } else {
          yield put(doPopup('SESSION_EXPIRED'))
        }
      } else {
        yield delay(1000)
        yield ttlControl()
      }
    } else {
      updateTTL() // update ttl for the first time when session is created
      yield ttlControl() // call the function again to check the ttl before updateTTL function
    }
  }
}

// @generator saga

// @generator saga:watch
export function* watchTtlControl() {
  yield takeLatest(actions.actionTypes.DO_TTL_CONTROL, ttlControl)
}
/**
 * Root saga manages watcher lifecycle
 */
export default function* rootSaga() {
  yield all([
    watchTtlControl()
    // @generator saga:fork
  ])
}
